import React, { useEffect, useState } from 'react';
import { useLocale } from './OrganizacjaI18n';
const OWNER = 'lucas7602@gmail.com';
const PENDING_KEY = 'taldigi.org.pending-login.v1';
const RETRY_KEY = 'taldigi.org.login-retry.v1';
function readStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
}
function storeValue(key, value) {
  try {
    if (value === null) localStorage.removeItem(key);else localStorage.setItem(key, JSON.stringify(value));
  } catch {/* The email link also restores the form if browser storage is unavailable. */}
}
function validPending(value) {
  return value && /^[A-Za-z0-9_-]{43}$/.test(value.challenge) && Number.isFinite(value.expiresAt) && value.expiresAt > Date.now() && value.expiresAt <= Date.now() + 15 * 60 * 1000 ? value : null;
}
function readPending() {
  const params = new URLSearchParams(window.location.hash.slice(1));
  if (params.has('login')) {
    return validPending({
      challenge: params.get('login'),
      expiresAt: Number(params.get('expires'))
    });
  }
  return validPending(readStorage(PENDING_KEY));
}
function readRetry() {
  const value = readStorage(RETRY_KEY);
  return Number.isFinite(value) && value > Date.now() && value <= Date.now() + 86400000 ? value : 0;
}
export default function Login({
  onLogin,
  request,
  Icon
}) {
  const {
    t,
    language
  } = useLocale();
  const [email, setEmail] = useState(OWNER);
  const [pending, setPending] = useState(readPending);
  const [retryUntil, setRetryUntil] = useState(readRetry);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    if (params.has('login')) {
      if (!readPending()) setError("Ten link do kodu wygasł. Poproś o nowy kod.");
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }
    const tick = () => setNow(Date.now());
    const timer = setInterval(tick, 1000);
    window.addEventListener('focus', tick);
    document.addEventListener('visibilitychange', tick);
    const sync = event => {
      if (event.key === PENDING_KEY) {
        setPending(validPending(readStorage(PENDING_KEY)));
        setCode('');
      }
      if (event.key === RETRY_KEY) setRetryUntil(readRetry());
    };
    window.addEventListener('storage', sync);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', tick);
      document.removeEventListener('visibilitychange', tick);
      window.removeEventListener('storage', sync);
    };
  }, []);

  // Only the incomplete challenge is retained. The code and authenticated
  // session never enter browser storage; the session uses an HttpOnly cookie.
  useEffect(() => {
    storeValue(PENDING_KEY, pending);
  }, [pending]);
  useEffect(() => {
    storeValue(RETRY_KEY, retryUntil || null);
  }, [retryUntil]);
  useEffect(() => {
    if (pending && pending.expiresAt <= now && !busy) {
      setPending(null);
      setCode('');
      setError("Ten kod wygasł. Poproś o nowy kod.");
    }
  }, [pending, now, busy]);
  const wait = Math.max(0, Math.ceil((retryUntil - now) / 1000));
  const waitText = wait >= 60 ? `${Math.floor(wait / 60)}:${String(wait % 60).padStart(2, '0')}` : `${wait} s`;
  async function checkBrowser() {
    let check = await request('cookie-check');
    if (!check.cookiesAvailable) check = await request('cookie-check');
    if (!check.cookiesAvailable) throw new Error("Ta przeglądarka nie zapamiętuje logowania. Otwórz tę stronę w Safari i spróbuj ponownie.");
  }
  async function sendCode() {
    if (busy || wait > 0) return;
    setBusy(true);
    setError('');
    try {
      await checkBrowser();
      const result = await request('login', 'POST', {
        email,
        language
      });
      const sentAt = Date.now();
      const next = validPending({
        challenge: result.challenge,
        expiresAt: result.expiresAt || sentAt + 600000
      });
      if (!next) throw new Error("Nie udało się rozpocząć logowania. Spróbuj ponownie.");
      storeValue(PENDING_KEY, next);
      setPending(next);
      setCode('');
      setNow(sentAt);
      setRetryUntil(sentAt + (result.retryAfter || 60) * 1000);
    } catch (e) {
      setError(e.message);
      if (e.retryAfter) {
        setNow(Date.now());
        setRetryUntil(Date.now() + e.retryAfter * 1000);
      }
    } finally {
      setBusy(false);
    }
  }
  async function submit(event) {
    event.preventDefault();
    if (!pending) {
      await sendCode();
      return;
    }
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      if (!pending.verified) {
        await checkBrowser();
        await request('verify', 'POST', {
          challenge: pending.challenge,
          code: code.replace(/\s/g, '')
        });
        setPending({
          ...pending,
          verified: true
        });
        setCode('');
      }
      await onLogin();
      storeValue(PENDING_KEY, null);
      setPending(null);
      setCode('');
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return <div className="org-login">
    <div className="org-login-mark"><Icon name="lock" /></div>
    <p className="org-kicker">{t("TWOJA PRYWATNA PRZESTRZEŃ")}</p>
    <h1>{t("Wszystko")}<br />{t("po kolei.")}</h1>
    <p>{t("Jeden plan. Mniej rzeczy do pamiętania.")}</p>
    <form onSubmit={submit}>
      {pending?.verified ? <p className="org-hint">{t("Kod potwierdzony. Możesz ponownie otworzyć plan bez wpisywania kodu.")}</p> : pending ? <>
        <label htmlFor="org-code">{t("Kod z wiadomości e-mail")}</label>
        <p className="org-hint">{t("Wysłany na ")}{OWNER}{t(". Skopiuj osiem cyfr z wiadomości i wróć tutaj. Kod jest ważny 10 minut.")}</p>
        <input id="org-code" className="org-code" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 8))} inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{8}" minLength={8} maxLength={8} autoFocus required placeholder="00000000" />
      </> : <>
        <label htmlFor="org-email">{t("Twój adres e-mail")}</label>
        <input id="org-email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} required />
        <p className="org-hint">{t("Dostęp ma wyłącznie właściciel tego planu.")}</p>
      </>}
      {error && <p className="org-error" role="alert">{t(error)}</p>}
      <button className="org-primary" disabled={busy || (!pending && wait > 0)}>
        {busy ? t("Chwila…") : pending?.verified ? t("Spróbuj otworzyć plan") : pending ? t("Otwórz mój plan") : wait > 0 ? t('Nowy kod za ') + waitText : t("Wyślij kod logowania")}
        <Icon name="arrow" />
      </button>
      {pending && <button type="button" className="org-link" disabled={busy || wait > 0} onClick={sendCode}>
        {wait > 0 ? t('Nowy kod za ') + waitText : t("Wyślij nowy kod")}
      </button>}
    </form>
    <div className="org-login-foot"><Icon name="lock" /><span>{t("Bez hasła. Plan dostępny po potwierdzeniu e-maila.")}</span></div>
  </div>;
}
